import { Heat } from "graphql/generated/types";
import { HeatLeaderboardStatus } from "./HeatLeaderboardStatus";

export const getHeatStatus = (heat: Heat) => {
    const isFinished = !!heat.endTime,
        isLive = !isFinished && !!heat.startTime,
        isUpcoming = !isFinished && !isLive;
    return { isFinished, isLive, isUpcoming };
};

export const HeatStatus: React.FC<{ heat: Heat; hideTimer?: boolean }> = ({
    heat,
    hideTimer,
}) => (
    <HeatLeaderboardStatus
        heat={heat}
        hideTimer={hideTimer}
        {...getHeatStatus(heat)}
    />
);
